import { Button, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useBranding } from '../stores/branding'

export default function LandingPage() {
  const navigate = useNavigate()
  const branding = useBranding()
  const companyName = branding.data?.product_name ?? 'NetCell IT'
  const logoUrl = branding.data?.logo_url

  return (
    <div className="landing-page">
      <div className="landing-card">
        {logoUrl ? (
          <img src={logoUrl} alt={companyName} className="landing-logo" />
        ) : (
          <div className="landing-company-name">{companyName}</div>
        )}
        <h1 className="landing-title">Kundenportal</h1>
        <p className="landing-subtitle">
          Verwalten Sie Ihre Dienste, Rechnungen und Support-Tickets.
        </p>
        <Space direction="vertical" className="w-full">
          <Button
            type="primary"
            size="large"
            block
            onClick={() => navigate('/portal/login')}
          >
            Zum Kundenportal
          </Button>
          <Button
            size="large"
            block
            onClick={() => navigate('/status')}
          >
            Systemstatus
          </Button>
        </Space>
        <div className="landing-footer">
          <a href="/kb">Wissensdatenbank</a>
          <span className="landing-footer-sep">·</span>
          <a href="/portal/datenschutz">Datenschutz</a>
        </div>
      </div>
    </div>
  )
}
